"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntlWrapper = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var translations_1 = require("./translations");
var formats = {
    time: {
        hhmm: {
            hour: "numeric",
            minute: "2-digit",
        },
    },
    date: {
        shortWithoutYear: {
            day: "numeric",
            month: "short",
        },
        shortWithYear: {
            day: "numeric",
            month: "short",
            year: "numeric",
        },
    },
};
/**
 * @internal
 */
exports.IntlWrapper = function (_a) {
    var children = _a.children, _b = _a.locale, locale = _b === void 0 ? sdk_ui_1.DefaultLocale : _b;
    var render = react_1.useCallback(function (modifiedTranslations) { return (react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, messages: modifiedTranslations, formats: formats }, children)); }, [locale, children]);
    return react_1.default.createElement(sdk_ui_1.TranslationsCustomizationProvider, { translations: translations_1.translations[locale], render: render });
};
//# sourceMappingURL=IntlWrapper.js.map